module.exports = __webpack_public_path__ + "media/images/application/template/logos/safehire-certified-company-608619b22a557ca67aecc701f1408ca8.png";